import {t} from 'i18next'
import {Column} from 'primereact/column'
import {DataTable} from 'primereact/datatable'
import {Fieldset} from 'primereact/fieldset'
import React from 'react'
import i18n from '../../../../../i18n'
import {getPhoneType} from '../../../../../util/phone'
import {FormattedPhoneNumberTableEntry} from '../../../../util/formatted-phone-number/FormattedPhoneNumber'
import {clothSize} from '../constants/clothSize.const'
import {confessions} from '../constants/confessions.const'
import {dominantHand} from '../constants/dominantHand.const'
import {driverLicense} from '../constants/driverLicense.const'
import {nativeLanguage} from '../constants/nativeLanguage.const'
import {salutations} from '../constants/salutations.const'
import {getBirthdate, getCity, getStreet} from '../Helper'
import {StaticViewProps} from '../interfaces/StaticViewProps'

export const StaticView = (props: StaticViewProps) => {
	const {person, company} = props

	return (
		<div>
			<Fieldset className={'m-2'} legend={i18n.t<string>('hrm.general')}>
				<div className=" p-fluid formgrid grid">
					<div className="field col-6">
						<label style={{display: 'inline-block'}} className="font-bold" htmlFor="salutation">
							{i18n.t<string>('person.salutation')}
						</label>
						<div className="salutation">
							{salutations.find(salutation => salutation.value === person?.salutation)?.label}
						</div>
					</div>
					<div className="field col-6"/>
					<div className="field col-6">
						<label className="font-bold" htmlFor="firstname">
							{i18n.t<string>('person.first_name')}
						</label>
						<div className="firstname">
							{person?.first_name}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="lastname">
							{i18n.t<string>('person.last_name')}
						</label>
						<div className="lastname">
							{person?.last_name}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="email">
							{i18n.t<string>('person.email')}
						</label>
						<div className="email">
							{person?.email}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="birthdate">
							{i18n.t<string>('person.birthdate')}
						</label>
						<div className="birthdate">
							{getBirthdate(person?.birthdate)}
						</div>
					</div>
					{/*TODO implement after HRM>detailview rework has been merged */}
					<div className="field col-6">

						<label className="font-bold" htmlFor="city">
							{i18n.t<string>('person.city')}
						</label>
						<div className="city">
							{getCity(person)}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="street">
							{i18n.t<string>('person.street')}
						</label>
						<div className="street">
							{getStreet(person)}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="company">
							{i18n.t<string>('company.company_name')}
						</label>
						<div className="company">
							{company?.company_name}
						</div>
					</div>
					<div className="field col-6">
						<DataTable
							className={'p-datatable'}
							value={person?.phone}
							dataKey="phone_id"
							scrollable
							header={t<string>('person.phone_list')}
							emptyMessage={t<string>('phone.no_number')}
							scrollHeight={'20vh'}
							columnResizeMode="expand"
							responsiveLayout={'scroll'}
						>
							<Column
								field="phone_type"
								body={getPhoneType}
								style={{minWidth: '3em', maxWidth: '3em'}}/>
							<Column
								field="phone_number"
								body={row => FormattedPhoneNumberTableEntry(row.phone_number)}
								/>
						</DataTable>

					</div>
				</div>
			</Fieldset>
			<Fieldset className={'m-2'} legend={i18n.t<string>('hrm.advanced')}>
				<div className=" p-fluid formgrid  grid">
					<div className="field col-6">
						<label className="font-bold" htmlFor="bank">
							{i18n.t<string>('person.bank_name')}
						</label>
						<div className="bank">
							{person?.bank_name}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="insurance_number">
							{i18n.t<string>('person.health_insurance_number')}
						</label>
						<div className="insurance_number">
							{person?.health_insurance_number}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="iban">
							{i18n.t<string>('person.iban')}
						</label>
						<div className="iban">
							{person?.iban}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="slack_id">
							{i18n.t<string>('person.slack_user_id')}
						</label>
						<div className="slack_id">
							{person?.slack_user_id}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="workload">
							{i18n.t<string>('person.workload_in_percent')}
						</label>
						<div className="workload">
							{person?.workload_in_percent + '%'}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="language">
							{i18n.t<string>('person.language')}
						</label>
						<div className="language">
							{nativeLanguage.find(language => language.value === person?.id_first_language)?.label}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="confession">
							{i18n.t<string>('person.confession')}
						</label>
						<div className="confession">
							{confessions.find(confession => confession.value === person?.confession)?.label}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="cloth_size">
							{i18n.t<string>('person.cloth_size')}
						</label>
						<div className="cloth_size">
							{clothSize.find(size => size.value === person?.cloth_size)?.label}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="dominant_hand">
							{i18n.t<string>('person.dominant_hand')}
						</label>
						<div className="dominant_hand">
							{dominantHand.find(hand => hand.value === person?.dominant_hand)?.label}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="vehicle_license">
							{i18n.t<string>('person.vehicle_license')}
						</label>
						<div className="vehicle_license">
							{driverLicense.find(license => license.value === person?.vehicle_license)?.label}
						</div>
					</div>
					<div className="field col-6">
						<label className="font-bold" htmlFor="public_transport">
							{i18n.t<string>('person.public_transport.title')}
						</label>
						<div className="travel_card">
							{person?.travel_card || ''}
						</div>
					</div>
				</div>
			</Fieldset>
		</div>
	)
}
